import {
    createNotification,
    INotificationBusinessLogic,
    Notification,
} from '@vfde-brix/ws10/notification';
import { DEVICE_NOTIFICATION } from 'Container/App/constants';
import {
    selectHasActiveDevice,
    selectHasDevice,
    toggleDevice,
} from 'Container/App/slice';
import { useDispatch } from '../store';
import { startAppListening } from 'Container/App/listener';

/**
 * mountNotification
 */
export const mountNotification = (selector: string, businessLogic: INotificationBusinessLogic): Notification | null => {
    const container = document.getElementById(selector);

    return container && createNotification(container, businessLogic);
};

/**
 * Mount device notification and bind event listener
 */
export const mountDeviceNotification = (): Notification | null => {
    const dispatch = useDispatch();

    const onClick: INotificationBusinessLogic['onClick'] = (event: Event, linkIndex, href) => {
        event.preventDefault();

        // Restore device button
        if (linkIndex === 0) {
            dispatch(toggleDevice());
        }

        // Go to "Alle Smartphones"
        if (linkIndex === 1) {
            event.preventDefault();
            window.location.assign(href);
        }
    };

    const notification = mountNotification(DEVICE_NOTIFICATION, { onClick });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectHasDevice(currentState) !== selectHasDevice(previousState)
            || selectHasActiveDevice(currentState) !== selectHasActiveDevice(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const hasActiveDevice = selectHasActiveDevice(api.getState());

            notification?.toggleContainer(hasActiveDevice);
        },
    });

    return notification;
};
